import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import NP from "../../../1. Core/NP";
import {FighterRecordWidgetMetadata, IAthlete, Widget} from "../../types";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {WidgetType} from "../WEnum";
import SelectFighterCtrl from "../../../2. Athletes/SelectFighterCtrl";
import Select from "../../../1. Core/Controls/Select/Select";
import ColorPicker from "../../../1. Core/Controls/ColorPicker/ColorPicker";


export default class FighterRecordWidgetEditDialog extends Dialog {
	private _name: TextField;

	private _backgoundUrlInput: TextField;

	private _Widget: Widget<FighterRecordWidgetMetadata>;

	private _previewFrame: HTMLFrameElement;
	private _timeId: any;
	private _leftTopLogoUrlInput: TextField;
	private _logoRightBottomLogoUrlInput: TextField;
	private _photoUrlInput: TextField;
	private _fighterNameInput: TextField;
	private _selectFighter: SelectFighterCtrl;
	private _fontCombo: Select;
	private _fontColor: ColorPicker;
	private _titleInput: TextField;
	private _SelectedAthlete: IAthlete;

	_initFields(settings: object)
	{
		this._SelectedAthlete = null
		this._Widget = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('FighterRecordWidget');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 1600;
	}

	_render()
	{
		super._render();

		let flexNode = NP.createNode(this._contentNode, 'widget-dlg-content-node')
		let leftNode = NP.createNode(flexNode, 'widget-dlg-settings-node')
		this._contentDomNode.style.maxWidth = '1600px'

		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: leftNode
		});

		this._selectFighter = new SelectFighterCtrl({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Athlete'),
			EvSelected: () => this.onSettingsChanged()
		})

		this._fighterNameInput = new TextField({
			FloatingLabel: NP.RM.getString('WidgetAthleteName'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._titleInput = new TextField({
			FloatingLabel: NP.RM.getString('Title'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._backgoundUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('Background'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._fontCombo = new Select({
			ParentNode: leftNode,
			Value: 'Muller',
			Items: [
				{Content: 'Muller', Value: 'Muller'},
				{Content: 'Roboto', Value: 'Roboto'},
				{Content: 'Corbert', Value: 'Corbert'},
				{Content: 'Bourgeois', Value: 'Bourgeois'},
				{Content: 'Swis', Value: 'Swis721 Blk BT'},
				{Content: 'PF Din Text Comp Pro', Value: 'PF Din Text Comp Pro'}
			],
			FloatingLabel: NP.RM.getString('FontFamily'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._fontColor = new ColorPicker({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('FontColor'),
			EvColorChanged: () => this.onSettingsChanged()
		})

		this._photoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('PhotoUrl'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._leftTopLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('RightLogo'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._logoRightBottomLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('LogoRightBottom'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});


		this._previewFrame = NP.createNode(flexNode, '', 'iframe');

		if (this._Widget)
		{
			this._selectFighter.setValue(this._Widget.Metadata.FighterId)
			this._name.setValue(this._Widget.Name)
			this._fighterNameInput.setValue(this._Widget.Metadata.FighterName)
			this._titleInput.setValue(this._Widget.Metadata.Title)
			this._photoUrlInput.setValue(this._Widget.Metadata.PhotoUrl)
			this._backgoundUrlInput.setValue(this._Widget.Metadata.Background)
			this._leftTopLogoUrlInput.setValue(this._Widget.Metadata.LogoLeftTop)
			this._logoRightBottomLogoUrlInput.setValue(this._Widget.Metadata.LogoRightBottom);
			this._fontColor.setValue(this._Widget.Metadata.FontColor || 'black')
			this._fontCombo.setValue(this._Widget.Metadata.FontFamily || 'Muller')
		}


		if (!this._Widget)
		{
			this._Widget = {
				Metadata: {WId: WidgetType.FighterRecord}
			} as Widget<FighterRecordWidgetMetadata>

			if (this._SelectedAthlete)
			{
				this._selectFighter.setValue(this._SelectedAthlete.Id)
				this._name.setValue(`MMA FIGHT RECORD -${this._SelectedAthlete.FirstName} ${this._SelectedAthlete.LastName}`)
				this._titleInput.setValue('MMA FIGHT RECORD');
				this._backgoundUrlInput.setValue('https://storage.yandexcloud.net/bd-sport-images/bblack.jpg')
				this._fontColor.setValue('white')
				this.updatePreview()
			}
		}
	}

	onSettingsChanged()
	{
		if (this._timeId)
			clearTimeout(this._timeId);

		this._timeId = setTimeout(() => this.updatePreview(), 200);
	}

	updateObjSettings()
	{
		this._Widget.Name = this._name.getValue()
		this._Widget.Metadata.FighterId = this._selectFighter.getValue();
		this._Widget.Metadata.FighterName = this._fighterNameInput.getValue();
		this._Widget.Metadata.Title = this._titleInput.getValue()

		this._Widget.Metadata.PhotoUrl = this._photoUrlInput.getValue()
		this._Widget.Metadata.Background = this._backgoundUrlInput.getValue()
		this._Widget.Metadata.LogoLeftTop = this._leftTopLogoUrlInput.getValue()
		this._Widget.Metadata.LogoRightBottom = this._logoRightBottomLogoUrlInput.getValue()
		this._Widget.Metadata.FontFamily = this._fontCombo.getValue();


		this._Widget.Metadata.FontColor = this._fontColor.getValue()
	}

	updatePreview()
	{
		this.updateObjSettings();

		if (this._Widget.Metadata.FighterId)
			this._previewFrame.src = `/cwidget/fighter-record?id=${this._Widget.Id || -1}&lang=${NP.getCurrentCulture().Name}&json=${encodeURIComponent(JSON.stringify(this._Widget))}`
	}

	async refresh()
	{

	}

	async _onOkButtonClick()
	{
		this.updateObjSettings();

		if (this._Widget.Id)
			await ServerAPI.callUiApi(`/widget/${this._Widget.Id}`, this._Widget, 'POST');
		else
			await ServerAPI.callUiApi("/widget", this._Widget, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}